@import '~style-sheet-helpers/core.less';

.modal-body {
  padding: 16px 16px 64px;
  font-size: 14px;
  line-height: 20px;
}
